import React, { useState, useEffect } from 'react';
import * as ScenarioAPI from '../../../services/ScenarioServices';
import * as RatingAPI from '../../../services/RatingServices';
import styles from './styles/ScenarioAbout.module.css';
import { useParams, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../../../context/AuthContext';
import ScenarioComments from './ScenarioComments';
import { transformIframes } from '../../../utils/utils';
import blankImage from '../../../images/network2.jpg';

const ScenarioAbout = () => {
    const { scenarioId } = useParams();
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const [scenario, setScenario] = useState(null);
    const [userRating, setUserRating] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchScenarioData = async () => {
            setLoading(true);
            setError(null);

            try {
                const scenarioReq = ScenarioAPI.getScenario(scenarioId, 'creator,tags');

                const ratingReq = RatingAPI.getUserRating(scenarioId).catch(() => ({ score: 0 }));

                const [scenarioData, ratingRes] = await Promise.all([scenarioReq, ratingReq]);

                setScenario(scenarioData);
                console.log("scenario comments count: ", scenarioData.commentsCount);
                setUserRating(ratingRes.score);
            } catch (err) {
                if (err.response?.status === 404) {
                    setError('Scenario not found.');
                } else {
                    setError('A server error occurred.');
                }
            } finally {
                setLoading(false);
            }
        };

        if (scenarioId) fetchScenarioData();
    }, [scenarioId]);

    const handleRate = async (score) => {
        const previousUserRating = userRating;
        const previousScenarioStats = { 
            avgRating: scenario.avgRating, 
            ratingsCount: scenario.ratingsCount 
        };

        setUserRating(score);

        try {
            const data = await RatingAPI.rateScenario(scenarioId, score);

            setScenario(prev => ({
                ...prev,
                avgRating: data.avgRating,
                ratingsCount: data.ratingsCount
            }));
        } catch (err) {
            setUserRating(previousUserRating);
            setScenario(prev => ({ ...prev, ...previousScenarioStats }));
            alert("Failed to save rating. Please try again.");
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading) return <div>Loading Scenario...</div>;
    if (error) return <div>{error}</div>;
    if (!scenario) return null;

    // OPTION 1

    // return (
    //     <div className={styles.container}>
    //         <section className={styles.heroCard}>
    //             <div className={styles.imageWrapper}>
    //                 <img src={scenario.image} alt={scenario.title} className={styles.scenarioImage} />
    //             </div>
                
    //             <div className={styles.heroContent}>
    //                 <h1 className={styles.title}>{scenario.title}</h1>
                    
    //                 <div className={styles.metaData}>
    //                     <p className={styles.creator}>
    //                         Created by:{' '}
    //                         <span 
    //                             className={styles.usernameLink}
    //                             onClick={() => navigate(`/user/${scenario.creator?.username}`)}
    //                         >
    //                             {scenario.creator?.username || "Unknown"}
    //                         </span>
    //                     </p>
    //                     <span className={scenario.isPrivate ? styles.badgePrivate : styles.badgePublic}>
    //                         {scenario.isPrivate ? "Password Protected" : "Public"}
    //                     </span>
    //                 </div>

    //                 <button 
    //                     className={styles.startButton} 
    //                     onClick={() => navigate(`/view/${scenarioId}`)}
    //                 >
    //                     Start Scenario
    //                 </button>
    //             </div>
    //         </section>

    //         <div className={styles.contentGrid}>
                
    //             <div className={styles.mainContent}>
    //                 <section className={styles.card}>
    //                     <h3 className={styles.sectionTitle}>Description</h3>
    //                     <div
    //                         className={styles.description}
    //                         dangerouslySetInnerHTML={{ __html: transformIframes(scenario.description) }}
    //                     />
    //                 </section>

    //                 <section className={styles.commentsWrapper}>
    //                     <ScenarioComments
    //                         originId={scenarioId}
    //                         onModel="Scenario" 
    //                         currentUser={user}
    //                     />
    //                 </section>
    //             </div>

    //             <aside className={styles.sidebar}>
    //                 <section className={styles.card}>
    //                     <h3 className={styles.sectionTitle}>Stats</h3>
    //                     <ul className={styles.statsList}>
    //                         <li>
    //                             <span className={styles.statLabel}>Views</span> 
    //                             <span className={styles.statValue}>{scenario.views}</span>
    //                         </li>
    //                         <li>
    //                             <span className={styles.statLabel}>Rating</span> 
    //                             <span className={styles.statValue}>
    //                                 {scenario.avgRating} / 5 <span className={styles.muted}>({scenario.ratingsCount} reviews)</span>
    //                             </span>
    //                         </li>
    //                         <li>
    //                             <span className={styles.statLabel}>Published</span> 
    //                             <span className={styles.statValue}>{formatDate(scenario.publishedAt)}</span>
    //                         </li>
    //                         <li>
    //                             <span className={styles.statLabel}>Updated</span> 
    //                             <span className={styles.statValue}>{formatDate(scenario.lastUpdated)}</span>
    //                         </li>
    //                     </ul>
    //                 </section>

    //                 <section className={styles.card}>
    //                     <h3 className={styles.sectionTitle}>Your Rating</h3>
    //                     <div className={styles.starRating}>
    //                         {[1, 2, 3, 4, 5].map((star) => (
    //                             <span 
    //                                 key={star} 
    //                                 onClick={() => handleRate(star)}
    //                                 className={`${styles.star} ${star <= userRating ? styles.starActive : ''}`}
    //                             >
    //                                 ★
    //                             </span>
    //                         ))}
    //                     </div>
    //                 </section>

    //                 {scenario.tags && scenario.tags.length > 0 && (
    //                     <section className={styles.card}>
    //                         <h3 className={styles.sectionTitle}>Tags</h3>
    //                         <div className={styles.tagsContainer}>
    //                             {scenario.tags.map(tag => (
    //                                 <span key={tag} className={styles.tag}>
    //                                     #{tag}
    //                                 </span>
    //                             ))}
    //                         </div>
    //                     </section>
    //                 )}
    //             </aside>
                
    //         </div>
    //     </div>
    // );

    // OPTION 2
    return (
        <div className={styles.container}>

            <section className={styles.hero}>
                <div className={styles.heroImageWrapper}>
                    <img
                        className={styles.heroImage}
                        src={scenario.image || blankImage}
                        alt={scenario.title}
                    />
                    <div className={styles.heroOverlay} />
                    <div className={styles.heroContent}>
                        <h1 className={styles.heroTitle}>{scenario.title}</h1>
                        <div className={styles.heroMeta}>
                            <span
                                className={styles.creatorLink}
                                onClick={() => navigate(`/user/${scenario.creator?.username}`)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => e.key === 'Enter' && navigate(`/user/${scenario.creator?.username}`)}
                                style={{ cursor: 'pointer' }}
                            >
                                {scenario.creator?.profilePicture && (
                                    <img
                                        src={scenario.creator.profilePicture}
                                        alt={scenario.creator.username}
                                        className={styles.creatorAvatar}
                                    />
                                )}
                                {scenario.creator?.username}
                            </span>
                            <span className={styles.visibilityBadge}>
                                {scenario.isPrivate ? '🔒 Password Protected' : '🌐 Public'}
                            </span>
                        </div>
                    </div>
                </div>
                <div className={styles.heroRight}>
                    <div className={styles.statsSection}>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>Views</span>
                            <span className={styles.statValue}>{scenario.views?.toLocaleString()}</span>
                        </div>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>Rating</span>
                            <span className={styles.statValue}>
                                <span className={styles.statValueAccent}>{scenario.avgRating}</span>
                                &thinsp;/ 5
                                <span style={{ color: 'var(--text-color-muted)', fontWeight: 400, fontSize: '0.82rem' }}>
                                    {' '}({scenario.ratingsCount} reviews)
                                </span>
                            </span>
                        </div>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>Published</span>
                            <span className={styles.statValue}>{formatDate(scenario.publishedAt)}</span>
                        </div>
                        <div className={styles.statItem}>
                            <span className={styles.statLabel}>Last Updated</span>
                            <span className={styles.statValue}>{formatDate(scenario.lastUpdated)}</span>
                        </div>
                    </div>
                    <button
                        className={styles.startButton}
                        onClick={() => navigate(`/view/${scenarioId}`)}
                    >
                        Start Scenario
                    </button>
                </div>
            </section>

            <section className={styles.ratingSection}>
                <span className={styles.sectionLabel}>Your Rating</span>
                <div className={styles.stars}>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span
                            key={star}
                            className={`${styles.star} ${star <= userRating ? styles.starFilled : ''}`}
                            onClick={() => handleRate(star)}
                            role="button"
                            aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && handleRate(star)}
                        >
                            ★
                        </span>
                    ))}
                </div>
                {userRating > 0 && (
                    <span className={styles.ratingHint}>You rated this {userRating}/5</span>
                )}
            </section>

            <section className={styles.descriptionSection}>
                <h3 className={styles.sectionTitle}>Description</h3>
                <div
                    className={styles.descriptionBody}
                    dangerouslySetInnerHTML={{ __html: transformIframes(scenario.description) }}
                />
            </section>

            {scenario.tags?.length > 0 && (
                <section className={styles.tagsSection}>
                    <h3 className={styles.sectionTitle}>Tags</h3>
                    <div className={styles.tagsContainer}>
                        {scenario.tags.map((tag) => (
                            <span key={tag._id} className={styles.tag}>#{tag.name}</span>
                        ))}
                    </div>
                </section>
            )}

            <div className={styles.commentsSection}>
                <ScenarioComments
                    originId={scenarioId}
                    onModel="Scenario"
                    currentUser={user}
                />
            </div>

        </div>
    );
};

export default ScenarioAbout;